export const sxCanvasHeight = (isMobile: boolean) => ({
  height: `calc(100vh - ${isMobile ? '144px' : '64px'})`,
});

export const sxMobileGroupBtn = {
  right: 0,
  bottom: 0,
  left: 0,
  justifyContent: 'space-between',
  gap: 1.5,
  p: 2,
  flexDirection: 'row',
};
